<div class="text-center">
  <p class="text text-danger">
    {{errorText}}
  </p>
  <button
    type="button"
    class="btn btn-primary btn-sm"
    (click)="doTryAgain($event)"
    i18n="@@checkout_sdk.action.try_again">
    checkout_sdk.action.try_again
  </button>
</div>
